import { IconType } from 'react-icons';
import { IoFolderOutline, IoPersonOutline, IoSettingsOutline } from 'react-icons/io5';

export default {
  '/': {
    to: '/',
    name: '내 프로젝트',
    Icon: IoFolderOutline,
  },
  '/setting/account': {
    to: '/setting/account',
    name: '내 계정 관리',
    Icon: IoPersonOutline,
  },
  '/setting/preference': {
    to: '/setting/preference',
    name: '환경설정',
    Icon: IoSettingsOutline,
  },
} as {
  [path: string]: {
    to: string;
    name: string;
    Icon: IconType;
  };
};
